export default {"src":"/_next/static/media/watch-flawless.6af2e536.svg","height":72,"width":62};